/* TIMEZONE REDUX — offset in whole hours (e.g. 5, -3, 0). Cached in localStorage. */

import { deviceOffsetHours } from "../helpers/timezone"

const stored = localStorage.getItem("timezone")
const DEFAULT = stored !== null && stored !== "" ? parseInt(stored, 10) : deviceOffsetHours()

const timezone = (state = DEFAULT, action) => {

    switch (action.type) {

        case "SET_TIMEZONE":
            localStorage.setItem("timezone", String(action.payload))
            return action.payload

        default:
            return state

    }
}

export default timezone
